export default {
  navigation: {
    next: "Seterusnya",
    back: "Kembali",
    surveyNavigation: "Navigasi tinjauan",
    workspace: {
      home: "Laman Utama",
      example: "Contoh"
    }
  }
}
